import React, {Component, useEffect} from "react";

import { Box, Button, Checkbox, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import {Picker} from "../Utils/Picker";
import {getDaysBetween} from "../../utils";
import RateCardPicker from "../Settings/RateCards/RateCardPicker";

export const RatesSection = ({rental, onChange, margins, suggestedRate, onRateCardChange, rateCards}) => {
  let days = 0
  let day1_2Rate, day3_6Rate, day7_27Rate, day28_plusRate = 0;
  let day1_2RateIns, day3_6RateIns, day7_27RateIns, day28_plusRateIns = 0;
  let day1_2RateAdm, day3_6RateAdm, day7_27RateAdm, day28_plusRateAdm = 0;

  if (rental.rate_card && rental.rate_card.id) {
    day1_2Rate = rental.rate_card.day1_2_rate * (1-(rental.day1_2_discount / 100)); // apply discount before other items are calculated
    day3_6Rate = rental.rate_card.day3_6_rate * (1-(rental.day_3_6_discount / 100));
    day7_27Rate = rental.rate_card.day7_27_rate * (1-(rental.day_7_27_discount / 100));
    day28_plusRate = rental.rate_card.day_28_plus_rate * (1-(rental.day_28_plus_discount / 100));

    day1_2RateIns = Math.round((day1_2Rate * rental.rate_card.insurance_perc) * 100) / 100;
    day3_6RateIns = Math.round((day3_6Rate * rental.rate_card.insurance_perc) * 100) / 100;
    day7_27RateIns = Math.round((day7_27Rate * rental.rate_card.insurance_perc) * 100) / 100;
    day28_plusRateIns = Math.round((day28_plusRate * rental.rate_card.insurance_perc) * 100) / 100;

    day1_2RateAdm = Math.round((day1_2Rate * rental.rate_card.admin_perc) * 100) / 100;
    day3_6RateAdm = Math.round((day3_6Rate * rental.rate_card.admin_perc) * 100) / 100;
    day7_27RateAdm = Math.round((day7_27Rate * rental.rate_card.admin_perc) * 100) / 100;
    day28_plusRateAdm = Math.round((day28_plusRate * rental.rate_card.admin_perc) * 100) / 100;
  }

  if (rental.start_date && rental.finish_date) {
    days = getDaysBetween(new Date(rental.start_date), new Date(rental.finish_date))
  }
  let totalHireCost = (Math.round( ((rental.short_term_total * 1.2) + rental.short_term_insurance_total + (rental.short_term_admin_total * 1.2)) * 100 )) / 100;



  const rentalMarginObjects = margins.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const getMileageExceeeded = () => {
    if (!rental.start_mileage || !rental.term || !rental.mileage_allowance || !rental.vehicle || !rental.vehicle.model) {
      return null
    } else {
      const totalMileage = (rental.mileage_allowance / 52 * rental.term) + rental.start_mileage;
      return (totalMileage > rental.vehicle.model.mileage_limit)
    }
  }

  const getTermMileage = () => {
    let termMileage = String(rental.mileage_allowance && rental.term ? rental.mileage_allowance * rental.term / 52 : 0)
    if (getMileageExceeeded()) {
      termMileage = termMileage + " WARNING - MILEAGE TOO HIGH"
    }
    return termMileage
  }
  const handleMarginChange = e => {
    let isBlank = e.target.value === 'BLANK' && e.target.key === -1;
    const toUpdate = {
      target: {
        name: "margin",
        value: isBlank ? {} : rentalMarginObjects[e.target.value]
      }
    }
    onChange(toUpdate)
  }

  const onCheck = (e) => {
      const toUpdate = {
          target: {
              name: e.target.name,
              value: e.target.checked
          }
      }
      onChange(toUpdate)
  }



  return (
    <Box>
      <Title>Rates</Title>
      <Columns isMultiline>
        <Column>
          <Field className="has-addons">
            <Control>
              <label className="label">Type</label>
              <Button
                color={rental.rental_type === "LT" ? "primary" : ""}
                onClick={() => onChange({target: {name: "rental_type", value: "LT"}})}
              >
                Long Term
              </Button>
              <Button
                color={rental.rental_type === "ST" ? "primary" : ""}
                onClick={() => onChange({target: {name: "rental_type", value: "ST"}})}
              >
                Short Term
              </Button>
              <Button
                color={rental.rental_type === "FOC" ? "primary" : ""}
                onClick={() => onChange({target: {name: "rental_type", value: "FOC"}})}
              >
                Free of Charge
              </Button>
            </Control>
          </Field>
        </Column>
        {rental.rental_type === "ST" &&
            <Column>
                <RateCardPicker
                    value={rental.rate_card}
                    editable={true}
                    disabled={false}
                    options={rateCards}
                    onChange={onRateCardChange}
                    inlineEdit={false}
                    blank={true}
                    label={"Rate Card (*)"}
                />
            </Column>
        }
      </Columns>
      {rental.rental_type === 'LT' &&
        <div>
          <Columns isMultiline>
            <Column>
              <Control>
                <Field>
                  <label className="label">Term (Weeks) (*)</label>
                  <Input
                    type="number"
                    name="term"
                    onChange={onChange}
                    value={rental.term}
                    required
                  />
                </Field>
              </Control>
            </Column>
            <Column>
              <Control>
                <Field>
                  <label className="label">Annual Mileage (*)</label>
                  <Input
                    type="number"
                    name="mileage_allowance"
                    onChange={onChange}
                    value={rental.mileage_allowance}
                    required
                  />
                </Field>
              </Control>
            </Column>

            <Column>
              <Field>
                <label className="label">Additional Costs (*)</label>
                <Control>
                  <Input
                    type="number"
                    name="additional_cost"
                    onChange={onChange}
                    value={String(rental.additional_cost)}
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Picker
                name={"margin"}
                label={"Margin (*)"}
                value={rental.margin}
                onChange={handleMarginChange}
                options={margins}
                optionField={"name"}
                blank={true}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <Field>
                  <label className="label">Rate Card Long Term Daily Rate</label>
                  <Control>
                    <Input
                      type={suggestedRate ? "number" : "text"}
                      onChange={onChange}
                      value={suggestedRate ? suggestedRate.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) : "Unable To Calculate Rate"}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Control>
                <label className="label">Override</label>
                <Checkbox
                  type="checkbox"
                  name="cost_override"
                  onChange={onCheck}
                  checked={rental.cost_override}
                />
              </Control>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Long Term Daily Rate (*)</label>
                  <Control>
                    <Input
                      type="number"
                      name="long_term_daily"
                      onChange={onChange}
                      value={String(rental.long_term_daily)}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Daily Insurance Charge (*)</label>
                  <Control>
                    <Input
                      type="number"
                      name="daily_insurance_charge"
                      onChange={onChange}
                      value={String(rental.daily_insurance_charge)}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
              <Column></Column>
              <Column></Column>
              <Column></Column>
              <Column>
                  <label className="label">Total Insurance Cost</label>
                  <Input
                    disabled={true}
                    value={(rental.daily_insurance_charge && rental.term) ? (rental.daily_insurance_charge * 7) * rental.term : 0}
                  />
              </Column>
          </Columns>
          <Title size="6">Term Totals</Title>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Total Mileage</label>
                <Control>
                  <Input
                    type="text"
                    value={getTermMileage()}
                    color={getMileageExceeeded() ? "danger" : ""}
                    textColor={getMileageExceeeded() ? "danger" : ""}
                    textWeight={getMileageExceeeded() ? "bold" : ""}
                    disabled
                    readOnly
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Total Cost</label>
                <Control>
                  <Input
                    type="number"
                    value={rental.total}
                    disabled
                    readOnly
                  />
                </Control>
              </Field>
            </Column>
          </Columns>
        </div>
      }
      {
        rental.rental_type === 'ST' &&
        <div>
          <Columns isMultiline>
              <Column>
                <label className="label">Apply Day 1-2 Rate</label>
                <Checkbox
                    checked={rental.apply_day1_2_rate}
                    name={"apply_day1_2_rate"}
                    onChange={onCheck}
                />
              </Column>
              <Column>
                <label className="label">Apply Day 3-6 Rate</label>
                <Checkbox
                    checked={rental.apply_day3_6_rate}
                    name={"apply_day3_6_rate"}
                    onChange={onCheck}
                />
              </Column>
              <Column>
                <label className="label">Apply Day 7-27 Rate</label>
                <Checkbox
                    checked={rental.apply_day7_27_rate}
                    name={"apply_day7_27_rate"}
                    onChange={onCheck}
                />
              </Column>
              <Column>
                <label className="label">Apply Day 28+ Rate</label>
                <Checkbox
                    checked={rental.apply_day_28_plus_rate}
                    name={"apply_day_28_plus_rate"}
                    onChange={onCheck}
                />
              </Column>
              <Column>
                <label className="label">Apply Insurance</label>
                <Checkbox
                    checked={rental.apply_insurance}
                    name={"apply_insurance"}
                    onChange={onCheck}
                />
              </Column>
              <Column>
                <label className="label">Apply Admin Fee</label>
                <Checkbox
                    checked={rental.apply_admin_fee}
                    name={"apply_admin_fee"}
                    onChange={onCheck}
                />
              </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 1-2 rate Discount (%)</label>
                  <Control>
                    <Input
                      type={"number"}
                      name="day1_2_discount"
                      value={rental.day1_2_discount}
                      onChange={onChange}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 3-6 rate Discount (%)</label>
                  <Control>
                    <Input
                      type={"number"}
                      name="day_3_6_discount"
                      value={rental.day_3_6_discount}
                      onChange={onChange}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
              <Column>
              <Field>
                <Field>
                  <label className="label">Day 7-27 rate Discount (%)</label>
                  <Control>
                    <Input
                      type={"number"}
                      name="day_7_27_discount"
                      value={rental.day_7_27_discount}
                      onChange={onChange}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 28+ rate Discount (%)</label>
                  <Control>
                    <Input
                      type={"number"}
                      name="day_28_plus_discount"
                      value={rental.day_28_plus_discount}
                      onChange={onChange}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 1-2 rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day1_rate"
                      value={day1_2Rate}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 3-6 rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day1_rate"
                      value={day3_6Rate}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
              <Column>
              <Field>
                <Field>
                  <label className="label">Day 7-27 rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day1_rate"
                      value={day7_27Rate}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 28+ rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day28_rate"
                      value={day28_plusRate}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
              <Column>
              <Field>
                <Field>
                  <label className="label">Day 1-2 Insurance Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day1_2_rate_insurance"
                      value={day1_2RateIns}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 3-6 Insurance Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day3_6_rate_insurance"
                      value={day3_6RateIns}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
              <Column>
              <Field>
                <Field>
                  <label className="label">Day 7-27 Insurance Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day7_27_rate_insurance"
                      value={day7_27RateIns}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 28+ Insurance Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day28_plus_rate_insurance"
                      value={day28_plusRateIns}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
              <Column>
              <Field>
                <Field>
                  <label className="label">Day 1-2 Admin Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day1_2_rate_admin"
                      value={day1_2RateAdm}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 3-6 Admin Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day3_6_rate_admin"
                      value={day3_6RateAdm}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
              <Column>
              <Field>
                <Field>
                  <label className="label">Day 7-27 Admin Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day7_27_rate_admin"
                      value={day7_27RateAdm}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Day 28+ Admin Rate</label>
                  <Control>
                    <Input
                      type={"text"}
                      name="day28_plus_rate_admin"
                      value={day28_plusRateAdm}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Control>
                <Field>
                  <label className="label">Daily Mileage (*)</label>
                  <Input
                    type="number"
                    name="mileage_allowance"
                    onChange={onChange}
                    value={rental.mileage_allowance}
                    required
                  />
                </Field>
              </Control>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Hire Days</label>
                  <Control>
                    <Input
                      type="number"
                      name="days"
                      value={rental.days}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Hire Total</label>
                  <Control>
                    <Input
                      type={"text"}
                      name={"short_term_total"}
                      onChange={onChange}
                      value={rental.short_term_total.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) || "Unable To Calculate Rate"}
                      disabled={!rental.cost_override}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Insurance Charge</label>
                  <Control>
                    <Input
                      type="number"
                      name="short_term_insurance_total"
                      onChange={onChange}
                      value={String(rental.short_term_insurance_total)}
                      disabled={!rental.cost_override}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Admin Charge</label>
                  <Control>
                    <Input
                      type="number"
                      name="short_term_admin_total"
                      onChange={onChange}
                      value={String(rental.short_term_admin_total)}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
            <Column>
              <Field>
                <Field>
                  <label className="label">Total Hire Cost (Inc VAT)</label>
                  <Control>
                    <Input
                      type="number"
                      name="short_term_total_hire"
                      value={totalHireCost}
                      disabled={true}
                    />
                  </Control>
                </Field>
              </Field>
            </Column>
          </Columns>
        </div>
      }
      {rental.rental_type === "FOC" &&
        <Columns isMultiline>
          <Column>
              <Field>
                <Field>
                  <label className="label">Daily Insurance Charge (*)</label>
                  <Control>
                    <Input
                      type="number"
                      name="daily_insurance_charge"
                      onChange={onChange}
                      value={String(rental.daily_insurance_charge)}
                    />
                  </Control>
                </Field>
              </Field>
          </Column>
          <Column>
              <Control>
                <Field>
                  <label className="label">Daily Mileage (*)</label>
                  <Input
                    type="number"
                    name="mileage_allowance"
                    onChange={onChange}
                    value={rental.mileage_allowance}
                    required
                  />
                </Field>
              </Control>
            </Column>
        </Columns>
      }
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Excess Mileage Cost (£ per mile) (*)</label>
            <Control>
              <Input
                name="excess_mileage_charge_per_mile"
                type="number"
                value={String(
                  rental.excess_mileage_charge_per_mile
                )}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Early Return Penalty</label>
            <Control>
              <Input
                name={"early_return_penalty"}
                value={rental.early_return_penalty}
                onChange={onChange}
                type={"number"}
              />
            </Control>
          </Field>
        </Column>
      </Columns>
      {rental.rental_type === "LT" &&
      <Columns isMultiline>
        <Column>
          <Field className="has-addons">
            <Control>
              <label className="label">Invoice Interval</label>
              <Button
                color={rental.invoice_interval === "ONE_OFF" ? "primary" : ""}
                onClick={() => onChange({target: {name: "invoice_interval", value: "ONE_OFF"}})}
              >
                One Off
              </Button>
              <Button
                color={rental.invoice_interval === "WEEKLY" ? "primary" : ""}
                onClick={() => onChange({target: {name: "invoice_interval", value: "WEEKLY"}})}
              >
                Weekly
              </Button>
              <Button
                color={rental.invoice_interval === "MONTHLY" ? "primary" : ""}
                onClick={() => onChange({target: {name: "invoice_interval", value: "MONTHLY"}})}
              >
                Monthly
              </Button>
            </Control>
          </Field>
        </Column>
      </Columns>
      }
    </Box>
  );
}

export default RatesSection;
